"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es7.object.values");
require("core-js/modules/es6.set");
var _slicedToArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _booking = require("@/api/bookSpace/booking");
var _vuex = require("vuex");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    form: {
      type: Object
    },
    cargoList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bookingTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    transportationTermsList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    paidTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rules: {
      type: Object
    },
    packageTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    differentKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    preLockFlag: {
      type: Boolean,
      default: null
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])), {}, {
    portNameDisabled: function portNameDisabled() {
      var porFlag = ['CNCKG', 'CNCDU', 'CNYBN', 'CNLUZ', 'CNZGG', 'CNNJG', 'CNDEY'].includes(this.form.por);
      var polFlag = ['CNQZH'].includes(this.form.pol);
      var KRXXXFlag = this.form.pol.startsWith('KR');
      var MYXXXFlag = this.form.pol.startsWith('MY');
      return !(porFlag || polFlag || KRXXXFlag || MYXXXFlag);
    },
    /**
     * @return {boolean}
     */
    CNXMNDisabled: function CNXMNDisabled() {
      return this.form.pol === 'CNXMN' && this.form.preLock === 1;
    }
  }),
  data: function data() {
    return {
      dataList: [],
      cargoListType: [{
        code: 0,
        name: 'Export'
      }, {
        code: '1',
        name: 'Reshipment'
      }],
      stuffTypeList: [{
        value: 2,
        name: 'CFS'
      }, {
        value: 3,
        name: 'CSL'
      }],
      expCustomsCntrTypeList: [{
        code: 2,
        name: 'Empty'
      }, {
        code: 0,
        name: 'Simple'
      }, {
        code: 1,
        name: 'Consolidated'
      }],
      isSplitList: [{
        value: '0',
        labelEh: 'NO',
        labelZh: '否'
      }, {
        value: '1',
        labelEh: 'YES',
        labelZh: '是'
      }],
      documentTypeList: [],
      webFeeItemComsDialogVisible: false,
      webBkYardComsDialogVisible: false,
      webBkDocumentComsVisible: false,
      vessNameVoy: '',
      packageTypeListKR: [{
        packageCode: "GT",
        packageName: "GT",
        packageNameCn: "GT"
      }],
      MYXXXArray: ['MYWSP', 'MYPKG', 'MYPGU', 'MYKUA', 'MYPEN']
    };
  },
  created: function created() {
    var _this = this;
    this.$dictionary.get(['DELIVERY_DOCMENT_METHOD'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.documentTypeList = res.DELIVERY_DOCMENT_METHOD ? res.DELIVERY_DOCMENT_METHOD : [];
    });
    if (this.form.stuffType === 1) {
      this.form.stuffType = null;
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    setTimeout(function () {
      _this2.queryMethod();
      _this2.vessNameVoy = _this2.form.vesselName + ' ' + _this2.form.voyageNo + _this2.form.voyageLeg;
      // console.log(this.form.webBkDocumentComs,'vessNameVoy')
      // if(this.form.webBkYardComs.length===0){
      //    this.form.webBkYardComs.push({pickupYard:'',returnYard:'',pickupDate:''})
      // }
    }, 1000);
  },
  methods: {
    validateNull: _validate.validateNull,
    changePorName: function changePorName(val) {
      this.form.webBkExtendComs[0].porName = val;
    },
    changePolName: function changePolName(val) {
      this.form.webBkExtendComs[0].polName = val;
    },
    changePodName: function changePodName(val) {
      this.form.webBkExtendComs[0].podName = val;
    },
    changeDelName: function changeDelName(val) {
      this.form.webBkExtendComs[0].delName = val;
    },
    handlePaidTypeChange: function handlePaidTypeChange(newVal) {
      if (newVal === 0) {
        this.form.paidPalce = this.form.pol;
      }
      if (newVal === 1) {
        this.form.paidPalce = this.form.del;
      }
    },
    findDuplicatesWithIndices: function findDuplicatesWithIndices(arr) {
      var elementMap = new Map();
      var duplicates = {};
      for (var i = 0; i < arr.length; i++) {
        var element = arr[i];
        if (!elementMap.has(element)) {
          elementMap.set(element, {
            count: 1,
            indices: i
          });
        } else {
          var _elementMap$get = elementMap.get(element),
            count = _elementMap$get.count,
            indices = _elementMap$get.indices;
          elementMap.set(element, {
            count: count + 1,
            indices: Math.max(indices, i)
          });

          // If the element is a duplicate (count > 1), store it in duplicates object
          if (count === 1) {
            duplicates[element] = [];
          }
          duplicates[element].push(i);
        }
      }
      // Filter out elements that are not duplicates (count <= 1)
      var result = {};
      var _iterator = (0, _createForOfIteratorHelper2.default)(elementMap),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
            _element = _step$value[0],
            _step$value$ = _step$value[1],
            _count = _step$value$.count,
            _indices = _step$value$.indices;
          if (_count > 1) {
            result[_element] = _indices;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return result;
    },
    handleClose: function handleClose() {
      var _this3 = this;
      var nowArray = this.form.webFeeItemComs.map(function (item) {
        return item.feeItem;
      });
      if (nowArray.length !== new Set(nowArray).size) {
        var myMap = this.findDuplicatesWithIndices(nowArray);
        this.$confirm(this.$t('home.validateFee1') + (Object.values(myMap)[0] + 1) + this.$t('home.validateFee2') + Object.keys(myMap)[0] + this.$t('home.validateFee3'), this.$t('confirmMsg.title'), {
          confirmButtonText: this.$t('confirmMsg.submit'),
          cancelButtonText: this.$t('confirmMsg.cancel'),
          type: 'warning'
        }).then(function () {
          _this3.webFeeItemComsDialogVisible = true;
        }).catch(function () {
          _this3.webFeeItemComsDialogVisible = true;
        });
        this.webFeeItemComsDialogVisible = true;
      }
    },
    hasBkDocumentNo: function hasBkDocumentNo() {
      if (!this.form.webBkDocumentComs || this.form.webBkDocumentComs.length === 0) {
        return false;
      }
      return this.form.webBkDocumentComs.some(function (item) {
        return !item.documentNo || item.documentNo.trim() === '';
      });
    },
    handleBKDocumentClose: function handleBKDocumentClose() {
      var _this4 = this;
      var hasInvalidBkDocumentsFlag = this.hasBkDocumentNo();
      if (hasInvalidBkDocumentsFlag) {
        // 阻止关闭，重新打开弹窗
        this.webBkDocumentComsVisible = true;
        this.$nextTick(function () {
          _this4.$message({
            message: _this4.$t('home.validateBkDocumentNo'),
            type: 'warning',
            duration: 1500
          });
        });
      } else {
        this.webBkDocumentComsVisible = false;
      }
    },
    queryMethod: function queryMethod() {
      var _this5 = this;
      var data = {
        currentPage: 1,
        pageSize: 1000,
        portCode: this.form.pol
      };
      (0, _booking.queryListPortFacility)(data).then(function (res) {
        _this5.dataList = res.data.records || [];
      });
    },
    inputClass: function inputClass(fileName) {
      return {
        'different': this.isDifferent(fileName)
      };
    },
    // isDifferent(fileName){
    //  return  this.differentKeys.includes(fileName)
    // },
    isDifferent: function isDifferent(fileName) {
      var _this6 = this;
      var fileNames = fileName.split(",");
      return fileNames.some(function (name) {
        return _this6.differentKeys.includes(name);
      });
    },
    handleOpenWebFeeItemComs: function handleOpenWebFeeItemComs() {
      this.webFeeItemComsDialogVisible = true;
    },
    handleOpenwebBkYardComs: function handleOpenwebBkYardComs() {
      this.webBkYardComsDialogVisible = true;
    },
    handleOpenwebBkDocumentComs: function handleOpenwebBkDocumentComs() {
      this.webBkDocumentComsVisible = true;
    },
    handleAddCharge: function handleAddCharge() {
      var data = {
        feeItem: '',
        payModel: '',
        id: '',
        rowStatus: 4
      };
      this.form.webFeeItemComs.push(data);
    },
    handleAddTerminalInfo: function handleAddTerminalInfo() {
      if (this.form.webBkYardComs.length <= 0) {
        var data = {
          pickupYard: '',
          returnYard: '',
          pickupDate: '',
          rowStatus: 4
        };
        this.form.webBkYardComs.push(data);
      }
    },
    handleRemoveCharge: function handleRemoveCharge(row, index) {
      if (row.bookingHeadWebComId) {
        row.rowStatus = 8;
        this.form.deleteWebFeeItemComs.push(row);
      }
      this.form.webFeeItemComs.splice(index, 1);
    },
    handleAddChargeBk: function handleAddChargeBk() {
      var data = {
        documentNo: '',
        packageCount: null,
        packageType: '',
        weight: null,
        isSplit: '',
        useTimes: null,
        id: '',
        rowStatus: 4
      };
      this.form.webBkDocumentComs.push(data);
    },
    handleRemoveBk: function handleRemoveBk(row, index) {
      console.log(row, 'row');
      if (row.bkDocumentWebComId) {
        row.rowStatus = 8;
        this.form.deleteWebBkDocumentComs.push(row);
      }
      this.form.webBkDocumentComs.splice(index, 1);
    }
  }
};